// lib
import { createAction } from "@reduxjs/toolkit";

// Direct UX
export const exclusiveLightEnable = createAction("presets/light/enableds/add");

export const addToEnableds = createAction("presets/enableds/add");
export const removeFromEnableds = createAction("presets/enableds/remove");

export const exclusiveEnableLocal = createAction("presets/locals/enable/exclusive");
export const addToLocalsAndEnable = createAction("presets/locals/addAndEnable");
export const removeFromLocals = createAction("presets/locals/remove");

export const addToFavoritesAndEnable = createAction("presets/favorites/addAndEnable");
export const removeFromFavorites = createAction("presets/favorites/remove");
export const updateFavorites = createAction("presets/favorites/update");

export const destroyPreset = createAction("presets/destroy");

export const qualifyPreset = createAction("presets/byId/qualify");

// Network callbacks
export const popularsRequest = createAction("presets/populars/request");
export const popularsSuccess = createAction("presets/populars/success");
export const popularsFailure = createAction("presets/populars/failure");

export const patchPrefsRequest = createAction("presets/prefs/patch/request");
export const patchPrefsSuccess = createAction("presets/prefs/patch/success");
export const patchPrefsFailure = createAction("presets/prefs/patch/failure");
